import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, ModalController } from '@ionic/angular';
import { Constants } from './constants/constants';
import { APIService } from './services/api/api.service';
import { AppearanceService } from './services/appearance/appearance.service';
import { AssetService } from './services/asset/asset.service';
import { ClientService } from './services/client/client.service';
import { DeviceService } from './services/device/device.service';
import { OrganisationService } from './services/organisation/organisation.service';
import { JobService } from './services/job/job.service';
import { LocationService } from './services/location/location.service';
import { TabService } from './services/tab/tab.service';
import { UserService } from './services/user/user.service';
import { ReportService } from './services/report/report.service';
import { BadgeModel } from './models/badge.model';
import { ModalNewOrganisationComponent } from './components/modal-new-organisation/modal-new-organisation.component';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  currentClientUid: number;
  selectedOrganisationUid: number;
  newClientUid: number;
  numberOfAlerts: number;
  stockBadge: number;

  public appPages = [
    { title: 'Login', url: '/login', icon: 'log-in', badge: null }
  ];


  
  constructor(private router: Router, private apiService: APIService, 
    public clientService: ClientService, public userService: UserService, private platform: Platform,
    private deviceService: DeviceService, public appearanceService: AppearanceService, 
    private assetService: AssetService, private jobService: JobService, 
    private organisationService: OrganisationService,
    private locationService: LocationService,
    private reportService: ReportService,
    private tabService: TabService,
    public modalController: ModalController) 
  {
    this.platform.ready().then(() => {

      this.listenToEvents();

    });
  }


  listenToEvents() 
  {

    this.appearanceService.listenForEvent('storage:loaded', (data: any) => {

        //this.loadFromLocalData();
    });

    this.appearanceService.listenForEvent('user:loggedin', (data: any) => {

      this.getUserDetails();
      this.currentClientUid = this.clientService.getClientUid();
      this.reloadBadgeCounter();

    });

    this.appearanceService.listenForEvent('user:loggedout', (data: any) => {

      this.userLoggedOut();

    });

    this.appearanceService.listenForEvent('badgeCounters:update', (data: any) => {

      this.reloadBadgeCounter();

    });
  }


  getUserDetails()
  {
    this.numberOfAlerts = this.clientService.getAlertBadgeCount();
    this.stockBadge = this.clientService.getStockBadgeCount();

    this.appPages = [
      { title: 'Analytics', url: '/analytics/0', icon: 'bar-chart', badge: null },
      { title: 'Client', url: '/client', icon: 'settings', badge: null },
      { title: 'Alerts', url: '/alerts/0', icon: 'notifications', badge:  this.numberOfAlerts},
      { title: 'Jobs', url: '/jobs/0', icon: 'briefcase', badge: null },
      { title: 'Locations', url: '/locations/0', icon: 'location', badge: null },
      { title: 'Stock Orders', url: '/stock/0', icon: 'basket', badge: this.stockBadge },
      { title: 'Stock Inventory', url: '/stockinventory/0', icon: 'bag', badge: null },
      { title: 'Stock Presets', url: '/stockpreset/0', icon: 'bag-add', badge: null },
      { title: 'Assets', url: '/assetlist/0', icon: 'documents', badge: null },
      { title: 'Asset Types', url: '/asset-types/0', icon: 'document-attach', badge: null },
      { title: 'Users', url: '/users/0', icon: 'people', badge: null },
      { title: 'Vehicles', url: '/vehicles/0', icon: 'car', badge: null },
      { title: 'Reports', url: '/reports/0', icon: 'reader', badge: null },
      { title: 'Devices', url: '/devices/0', icon: 'desktop', badge: null }
    ];
  }


  goToAccountPage()
  {

  }


  userLoggedOut()
  {
    this.appPages = [
      { title: 'Login', url: '/login', icon: 'log-in', badge: null }
    ];
  }


  reloadBadgeCounter()
  {
    this.clientService.getClientBadgeCount().subscribe(response => {

      this.numberOfAlerts = this.clientService.getAlertBadgeCount();
      this.appPages[2].badge = this.numberOfAlerts;

      this.stockBadge = this.clientService.getStockBadgeCount();
      this.appPages[5].badge = this.stockBadge;

    },              
    err => 
    {

    });
  }


  clientChangeSelected($event)
  {
    this.newClientUid = $event.target.value;

    if (this.currentClientUid != this.newClientUid)
    {
      this.selectedOrganisationUid = null;
      this.clientService.changeCurrentOrganisation(null);

      this.appearanceService.showLoading("Please wait...").then(() => {

        this.clientService.changeClient(this.newClientUid).subscribe(response => {
      
          this.appearanceService.dismissLoading();
  
          if (response.Success)
          {
            this.currentClientUid = this.newClientUid;
            this.newClientUid = null;
            this.appearanceService.presentToast("Client change.", Constants.TOAST_SUCCESS);

            this.getUserDetails();
            this.reloadBadgeCounter();

            this.appearanceService.triggerEvent('client:changed', {
                time: new Date()
            });
          }
          else
          {
            if (response.Message != "")
            {
              this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
            }
          }
        },
        err => {
  
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
  
        });
      });
    }
  }


  organisationChangeSelected($event)
  {
    if(isNaN($event.target.value))
    {
      this.selectedOrganisationUid = null;
    }
    else
    {
      this.selectedOrganisationUid = $event.target.value;
    }

    if (this.selectedOrganisationUid != this.clientService.getOrganisationUid())
    {
      this.clearPreviousRoute();

      this.appearanceService.showLoading("Please wait...").then(() => {

        this.clientService.changeCurrentOrganisation(this.selectedOrganisationUid).subscribe(response => {
      
          this.appearanceService.dismissLoading();
  
          if (response.Success)
          {
            this.appearanceService.presentToast("Organisation changed.", Constants.TOAST_SUCCESS);

            this.appearanceService.triggerEvent('client:changed', {
                time: new Date()
            });
          }
          else
          {
            if (response.Message != "")
            {
              this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
            }
          }
        },
        err => {
  
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
  
        });
      });
    }
  }


  async createNewOrganisation() 
  {
    const modal = await this.modalController.create({
      component: ModalNewOrganisationComponent,
      backdropDismiss: false,
      componentProps: { },
      cssClass: 'ninety8-screen-modal',
      id: 'NewOrganisationModal'
    });

    modal.onDidDismiss().then((response) => {

      if (response.data)
      {
        this.selectedOrganisationUid = response.data[0].uid;
        this.clientService.changeCurrentOrganisation(this.selectedOrganisationUid);

        this.appearanceService.triggerEvent('client:changed', {
            time: new Date()
        });
      }
    })

    return await modal.present();
  }


  clearPreviousRoute()
  {
    this.appearanceService.setRedirectPage(null);
  }
}
